(() => {
  'use strict';
  if (window.DietzHalloweenSession) return;
  const key = 'dietz_halloween_2026';
  const events = new EventTarget();
  let endpoint = 'https://dietz-halloween-wheel.vercel.app/api/wheel';
  let state = null, pending = null;
  const readToken = () => {
    try { const token = localStorage.getItem(key); if (token) return token; } catch (_) {}
    return document.cookie.split('; ').find(item => item.startsWith(`${key}=`))?.slice(key.length + 1) || null;
  };
  const saveToken = token => {
    try { localStorage.setItem(key, token); } catch (_) {}
    document.cookie = `${key}=${token}; Max-Age=5184000; Path=/; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`;
  };
  const publish = data => {
    state = { ...state, ...data };
    if (data.sessionToken) saveToken(data.sessionToken);
    events.dispatchEvent(new CustomEvent('change', { detail: state }));
    return state;
  };
  const locked = (action, fn) => navigator.locks?.request ? navigator.locks.request(`dietz-halloween-${action}`, fn) : fn();
  async function transport(action, body = {}) {
    const response = await fetch(`${endpoint}/${action}`, {
      method: 'POST', credentials: 'omit', cache: 'no-store',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionToken: readToken() || state?.sessionToken || null, ...body }),
      signal: AbortSignal.timeout(20000),
    });
    let data;
    try { data = await response.json(); } catch (_) { throw new Error('SERVICE_UNAVAILABLE'); }
    if (!response.ok) throw new Error(data.error || 'SERVICE_UNAVAILABLE');
    return data;
  }
  function status(force = false) {
    if (pending) return pending;
    if (state && !force) return Promise.resolve(state);
    pending = locked('identity', async () => publish(await transport('status'))).finally(() => { pending = null; });
    return pending;
  }
  async function request(action, body = {}) {
    if (action === 'status') return status(true);
    const data = await locked(action, async () => transport(action, body));
    publish({ claim: data.claim, blocked: false });
    channel?.postMessage('refresh');
    return data;
  }
  window.addEventListener('storage', event => {
    if (event.key === key) status(true).catch(() => {});
  });
  const channel = typeof BroadcastChannel === 'function' ? new BroadcastChannel('dietz-halloween-2026') : null;
  channel?.addEventListener('message', () => status(true).catch(() => {}));
  events.addEventListener('change', () => {
    document.dispatchEvent(new CustomEvent('dietz:halloween-state', { detail: state }));
  });
  window.DietzHalloweenSession = Object.freeze({
    configure(value) {
      if (value && (value.startsWith('/') || new URL(value).origin === 'https://dietz-halloween-wheel.vercel.app')) endpoint = value;
    },
    status, request,
    notifyOtherTabs() { channel?.postMessage('refresh'); },
    get state() { return state; },
    subscribe(listener) { events.addEventListener('change', listener); return () => events.removeEventListener('change', listener); },
  });
})();
